var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6425_41473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18.8517H8V10.8517H4V18.8517ZM10 18.8517H14V4.85168H10V18.8517ZM16 18.8517H20V12.8517H16V18.8517ZM2 18.8517V10.8517C2 10.3017 2.19583 9.83085 2.5875 9.43918C2.97917 9.04752 3.45 8.85168 4 8.85168H8V4.85168C8 4.30168 8.19583 3.83085 8.5875 3.43918C8.97917 3.04752 9.45 2.85168 10 2.85168H14C14.55 2.85168 15.0208 3.04752 15.4125 3.43918C15.8042 3.83085 16 4.30168 16 4.85168V10.8517H20C20.55 10.8517 21.0208 11.0475 21.4125 11.4392C21.8042 11.8309 22 12.3017 22 12.8517V18.8517C22 19.4017 21.8042 19.8725 21.4125 20.2642C21.0208 20.6559 20.55 20.8517 20 20.8517H4C3.45 20.8517 2.97917 20.6559 2.5875 20.2642C2.19583 19.8725 2 19.4017 2 18.8517Z",
    fill: "#BEB4AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6425_41473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBars);
export default __webpack_public_path__ + "static/media/graph_bars.82b5524f431b76441e65615d71047f8d.svg";
export { ForwardRef as ReactComponent };